import _ from "lodash";
import {
  checkStatus,
  parseJSON,
  getApiUrl,
  getHeaderForAjax,
} from "./ServiceHelper";
import { getLoggedInUser } from "./AuthenticationService";

export async function getNotifs() {
  const userId = await getLoggedInUser()._id;
  return await fetch(getApiUrl() + "/users/" + userId + "/inboxlist/" + "00", {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export function deleteNotifs(ids) {
  const userId = getLoggedInUser()._id;

  let url = getApiUrl() + "/users/" + userId + "/share/delete";
  const body = {
    ids: ids,
  };
  return (
    fetch(url, {
      method: "delete",
      headers: getHeaderForAjax(),
      body: JSON.stringify(body),
    })
      .then(checkStatus)
      .then((res) => {
        getLoggedInUser();
        return ids;
      })
      .catch((error) => console.log(error))
  );
}
export function acceptNotifs(ids) {
  const userId = getLoggedInUser()._id;

  let url = getApiUrl() + "/users/" + userId + "/share/accept";
  const body = {
    ids: ids,
  };
  return (
    fetch(url, {
      method: "POST",
      headers: getHeaderForAjax(),
      body: JSON.stringify(body),
    })
      .then(checkStatus)
      .then((res) => {
        getLoggedInUser();
        return ids;
      })
      .catch((error) => console.log(error))
  );
}



// WEBPACK FOOTER //
// ./src/services/InboxService.js